<template>
  <div class="bravado-empty-placeholder">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BravadoEmptyPlaceholder',
};
</script>

<style scoped lang="scss">
.bravado-empty-placeholder {
  background: var(--theme-color-over-card);
  width: 100%;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg, rgba(#fff, 0) 0, rgba(#fff, 0.15) 50%, rgba(#fff, 0));
    animation: shimmer 3s infinite;
  }
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
